import * as THREE from 'three';
import gsap from 'gsap';
import Exp from '../Exp';

export default class Environment {
    constructor() {
        this.experience = new Exp();
        this.scene = this.experience.scene;
        this.resources = this.experience.resources;
    }

    setLights() {
        this.multi = 3;

        this.directLight = new THREE.DirectionalLight(0xffffff, 0); //8
        this.directLight.position.set(3, 1.5, -1);
        this.directLight.target.position.set(0, 2, 0);
        this.directLight.castShadow = true;
        this.scene.add(this.directLight.target);
        this.scene.add(this.directLight);
        this.directLight.shadow.mapSize.width = 2048;
        this.directLight.shadow.mapSize.height = 2048;

        this.directLight2 = new THREE.DirectionalLight(0xffffff, 0); //6
        this.directLight2.position.set(-3, 1.5, -1);
        this.directLight2.target.position.set(0, 2, 0);
        this.directLight2.castShadow = true;
        this.scene.add(this.directLight2.target);
        this.scene.add(this.directLight2);
        this.directLight2.shadow.mapSize.width = 2048;
        this.directLight2.shadow.mapSize.height = 2048;

        this.directLight3 = new THREE.DirectionalLight(0xffffff, 0); //4
        this.directLight3.position.set(3, 2, 0);
        this.directLight3.target.position.set(0, 0, -1);
        this.directLight3.castShadow = true;
        this.scene.add(this.directLight3.target);
        this.scene.add(this.directLight3);

        this.directLight4 = new THREE.DirectionalLight(0xffffff, 0); //4
        this.directLight4.position.set(-3, 2, 0);
        this.directLight4.target.position.set(0, 0, -1);
        this.directLight4.castShadow = true;
        this.scene.add(this.directLight4.target);
        this.scene.add(this.directLight4);

        this.directLight5 = new THREE.DirectionalLight(0xffffff, 0); //6
        this.directLight5.position.set(0, 3, 2);
        this.directLight5.target.position.set(0, 0, -1);
        this.directLight5.castShadow = true;
        this.scene.add(this.directLight5.target);
        this.scene.add(this.directLight5);

        this.spotLight = new THREE.SpotLight(
            0xffffff,
            0, //2
            0,
            Math.PI / 4,
            .1,
            2 * 1
        );
        this.spotLight.penumbra = .75
        this.spotLight.position.set(-2, -3, -3);
        this.spotLight.castShadow = true;
        this.scene.add(this.spotLight)

        this.rimLight = new THREE.SpotLight(
            0xffffff,
            0, //2
            0,
            Math.PI / 4,
            .1,
            2 * 1
        );
        this.rimLight.penumbra = .75;
        this.rimLight.castShadow = true;
        this.rimLight.position.set(0, 0, -5);
        this.scene.add(this.rimLight);
    }

    animLights() {
        this.tlLight = gsap.timeline({
            defaults: {
                ease: "none"
            }
        });
        this.tlLight.to(this.spotLight.position, { x: -2.5, y: 0, duration: .6, delay: 1 })
            .to(this.spotLight, { intensity: 20 * this.multi, duration: .6 }, '<0')
            .to(this.spotLight.position, { x: -2, y: 3, duration: .6 }, '<0.6')
            .to(this.spotLight.position, { x: 2, y: 3, duration: .8, })
            .to(this.spotLight.position, { x: 2.5, y: 0, duration: .6, })
            .to(this.spotLight.position, { x: 2, y: -3, duration: .6, })
            .to(this.spotLight, { intensity: 0, duration: .6 }, '<0')

        this.tlLight2 = gsap.timeline({
            delay: this.tlLight.duration() / 3 * 2,
            onStart: () => {
                gsap.delayedCall(0.4, () => {
                    document.querySelector('.sc-home-hero').classList.remove('hide')
                    document.querySelector('.header').classList.remove('before-loading')
                })
            },
        });
        this.tlLight2
            .to(this.directLight, { intensity: 8 * this.multi, duration: 1.2 }, '>.4')
            .to(this.experience.materials.mtl_dark_skin, { envMapIntensity: 7, duration: .6 }, '<0')
            .to(this.experience.materials.mtl_dark, { envMapIntensity: 7, duration: .6 }, '<0')
            .set(this.experience.renderer.instance, { toneMapping: THREE.ACESFilmicToneMapping }, '0')
            .to(this.directLight2, { intensity: 6 * this.multi, duration: 1.2 }, '<0')
            .to([this.directLight3, this.directLight4, this.directLight5], { intensity: 4 * this.multi, duration: 1.2, stagger: 0.1 }, '<0')
            .to(this.rimLight, { intensity: 2 * this.multi, duration: 1.2 }, '<0')
            .to('.blur-bg', { opacity: .5, duration: .6 }, '<0')
    }

    setEnvironment() {
        this.environmentMap = {};
        this.environmentMap.intensity = 1;
        this.environmentMap.texture = this.resources.items.environmentMapTexture;
        console.log(this.environmentMap.texture)
        this.environmentMap.texture.encoding = THREE.sRGBEncoding;

        this.scene.environment = this.environmentMap.texture;
    }

}